import z from 'zod'
import type { $ZodType } from 'zod/v4/core'

const ExportOption = z.enum(['MAIL', 'DOWNLOAD', 'SAVE'])

export type ExportOption = z.infer<typeof ExportOption>

const ExportFormat = z.enum([
  'PDF',
  'PDF_SALARY',
  'EXCEL',
  'EXCEL_FLAT',
  'VISMA',
  'POWEROFFICE',
  'TWENTYFOUR_SEVEN_OFFICE',
  'TRIPLETEX',
  'ZIP',
])

export type ExportFormat = z.infer<typeof ExportFormat>

export function createAbsenceReportSchema<
  TObj extends Readonly<{ [k: string]: $ZodType }>,
  TOption extends ExportOption,
  TFormat extends ExportFormat,
>(
  obj: z.ZodObject<TObj>,
  options: TOption[],
  formats: TFormat[]
): z.ZodObject<
  TObj & {
    exportOption: z.ZodEnum<Readonly<Record<TOption, TOption>>>
    exportFormat: z.ZodEnum<Readonly<Record<TFormat, TFormat>>>
  }
> {
  return z.object({
    ...obj.shape,
    exportOption: ExportOption.extract(options),
    exportFormat: ExportFormat.extract(formats),
  })
}

export type AnyAbsenceReportSchema<
  TOption extends ExportOption,
  TFormat extends ExportFormat,
> = ReturnType<
  typeof createAbsenceReportSchema<
    Readonly<{ [k: string]: $ZodType }>,
    TOption,
    TFormat
  >
>
